//@flow
import {
  endpoints,
  createStoreLocationApi,
  deleteStoreLocationApi,
  getStoreLocationApi,
  listStoreLocationsApi,
  updateStoreLocationApi,
} from '../api/location';

import type {StoreLocation} from '../../../entities/store-location';
import {buildRoute} from '../../../http';

export function getStoreLocationService(
  locationId: string
): Promise<StoreLocation> {
  const route = buildRoute(endpoints.GET_STORE_LOCATION, [locationId]);
  return getStoreLocationApi(undefined, {route}).toPromise();
}

export function listStoreLocationsService(): Promise<Array<StoreLocation>> {
  return listStoreLocationsApi().toPromise();
}

export type CreateStoreLocationRequest = {
  name: string,
  address: string,
  mapUrl?: string,
  schedule?: string,
  phone?: string,
  enabled?: boolean,
};

export function createStoreLocationService(
  storeLocation: CreateStoreLocationRequest
): Promise<StoreLocation> {
  return createStoreLocationApi(storeLocation).toPromise();
}

export type UpdateStoreLocationRequest = {
  name?: string,
  address?: string,
  mapUrl?: string,
  schedule?: string,
  phone?: string,
  enabled?: boolean,
};

export function updateStoreLocationService(
  locationId: string,
  storeLocation: UpdateStoreLocationRequest
): Promise<StoreLocation> {
  const route = buildRoute(endpoints.UPDATE_STORE_LOCATION, [locationId]);
  return updateStoreLocationApi(storeLocation, {
    route,
  }).toPromise();
}

export function deleteStoreLocationService(locationId: string): Promise<void> {
  const route = buildRoute(endpoints.DELETE_STORE_LOCATION, [locationId]);
  return deleteStoreLocationApi({route}).toPromise();
}
